import MMenu from './mmenu'
import InView from './in-view'
import WaveEffect from './waves'
import InternalLinks from './internal-links'

export default {
  MMenu,
  InView,
  WaveEffect,
  InternalLinks
}



// WEBPACK FOOTER //
// ./resources/js/modules/index.js